import { useStores } from 'Hooks/useStore';
import VerificationCodeBlock from '../NewLogin/Components/VerificationCodeBlock';
import NewAuthLayout from '../NewLogin/layout/Layout';
import { Redirect } from 'react-router-dom';
import { getAppRoutes } from 'Pages/App/App.constants';

const NewTwoStepAuth: React.FC = () => {
	const { authStore } = useStores();

	if (authStore.twoFactorAuthorizationPassed) {
		return <Redirect to={getAppRoutes().HOME} />;
	}

	return (
		<NewAuthLayout variant="centered">
			<VerificationCodeBlock />
		</NewAuthLayout>
	);
};

export default NewTwoStepAuth;
